import { Injectable } from '@angular/core';
import { IAppConfig } from './app-config.model';
import { IEnvironmentConfig } from './env.config.model';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private envConfig: IEnvironmentConfig = {} as IEnvironmentConfig;
  private appConfig: IAppConfig = {} as IAppConfig;

  /** Called from APP_INITIALIZER with minimal dependencies */
  async loadAppConfigs(): Promise<IAppConfig> {
    const environmentConfig$ = fetch('/assets/config/env-settings.json').then((resp: Response) => {
      return resp.clone().json() as unknown as IEnvironmentConfig;
    });

    const appConfig$ = fetch('/assets/config/app-settings.json').then((resp: Response) => {
      return resp.clone().json() as unknown as IAppConfig;
    });

    this.envConfig = await environmentConfig$;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.envConfig.version = (window as any).version as string;
    this.appConfig = await appConfig$;

    return this.appConfig;
  }

  getAppValue<T>(key: keyof IAppConfig): T {
    return this.appConfig[key] as T;
  }

  getEnvValue<T>(key: keyof IEnvironmentConfig): T {
    return this.envConfig[key] as T;
  }

  getIsPlayground(): boolean {
    return !!(this.envConfig.env?.includes('play') || this.envConfig?.isPlayground);
  }

  getEnvConfig(): IEnvironmentConfig {
    return this.envConfig;
  }
}
